<div class="home-reel-wrapper w-100 h-100">
    <div class="content-wrapper" [ngClass]="{'animate':animateContent}">
        <div class="content-container">
            <p class="heading5 reels-header" [innerHtml]="content.header"></p>
            <h3 *ngIf="screenWidth > 767" class="heading3 font-bold heading-3-m" [innerHtml]="content.title"></h3>
             <h3 *ngIf="screenWidth <= 767" class="heading3 font-bold heading-3-m" [innerHtml]="content.title_mobile"></h3>
        </div>
        <div class="content-container-bottom">
            <a class="link1-mobile link-darker" routerLink="company" [ngClass]="{'d-none': screenWidth  > 1024}">{{content.get_to_know_us_button_label}}</a>
            <a class="link1 link-darker" routerLink="company" [ngClass]="{'d-none': screenWidth  <= 1024}">{{content.get_to_know_us_button_label}}</a>
        </div>
    </div>

    <div class="image-wrapper"
        inViewport
        [inViewportOptions]="{ threshold: [0] }"
        (inViewportAction)="onIntersection($event)"
        [ngClass]="{'animate':animateContent}">
        <h1 class="font-bold heading1  heading-1-m f-white d-block" [ngClass]="{'d-md-none':screenWidth > 1024 }">Works</h1>
        <a class="link1-mobile link-white" routerLink="works" [ngClass]="{'d-none': screenWidth  > 1024}">{{content.reel_button_label}}</a>
        <a class="link1 link-white" routerLink="works" [ngClass]="{'d-none': screenWidth  <= 1024}">{{content.reel_button_label}}</a>
        <div class="reel-inner-wrapper">
        </div>
        <div class="image-item" *ngFor="let gallery of reelgallery; let i = index" [ngClass]="{'active':activeSlide == i}">
             <img id="reel-image-{{i}}" (load)="imageLoaded(i)" src="{{gallery.image}}" alt="">
        </div>
    </div>
</div>
